module.exports = __webpack_public_path__ + "static/media/london_25-sits_oppet_avslut_tyg_mito_miljo_2023_3.f53eae26.jpg";